import { useQuery } from "@tanstack/react-query";

import type {
  ActorListOrderBy,
  ActorStatus,
  GenderType,
  Industry,
  LanguageCodes,
  SortOrder,
  VoiceLlm,
} from "Infrastructure/Api/Api";
import { getActors } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTORS_QUERY_KEYS } from "./queryKeys";

export interface ActorsQueryParams {
  offset?: number;
  limit?: number;
  searchQuery?: string | null;
  languages?: LanguageCodes[] | null;
  ages?: number[] | null;
  genders?: GenderType[] | null;
  priceCategoryID?: string;
  onlyOpenToCollaboration?: boolean | null;
  onlyWithActiveVoice?: boolean | null;
  excludeNotAllowed?: boolean;
  includeActorIDs?: string[] | null;
  voiceLlms?: VoiceLlm[] | null;
  actorStatus?: ActorStatus[] | null;
  industry?: Industry | null;
  orderBy?: ActorListOrderBy;
  sortOrder?: SortOrder;
}

export function useActorsQuery(params: ActorsQueryParams) {
  return useQuery({
    queryKey: ACTORS_QUERY_KEYS.list(params),
    queryFn: processResponse(() =>
      getActors(
        params.offset,
        params.limit,
        params.searchQuery,
        params.languages,
        params.ages,
        params.genders,
        params.priceCategoryID,
        params.onlyOpenToCollaboration,
        params.onlyWithActiveVoice,
        params.excludeNotAllowed,
        params.includeActorIDs,
        params.voiceLlms,
        params.industry,
        params.actorStatus,
        params.orderBy,
        params.sortOrder,
      ),
    ),
  });
}
